export const baseURL = "https://de.loksewapro.com/api/v1"
export const imageURL = "https://de.loksewapro.com"